<template>
  <div class="contents__title">
    <slot name="title"/>
    <h2 v-if="$slots.title === undefined">{{title}}</h2>
    <div class="icon-group-page">
      <slot name="rightTool"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WMainTitle',
  props: {
    title: {
      type: String,
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/template/MainTitle.vue